import { fetchAuthSession } from 'aws-amplify/auth';
import i18n from 'i18n';
import { AuthUser } from '../types';
import { useProductStore } from '../store/productStore';
import { useReceiptStore } from '../store/receiptStore';
import { useTrackingStore } from '../store/trackingStore';
import { useAppStore } from '../store/appStore';
import { SCREEN_TYPES } from './constants';
import { useArrivalReceiptStore } from 'store/arrivalReceiptStore';
import { isAdminGroup, resolveRoles } from './permissions';

export const getSessionUser = async (): Promise<AuthUser> => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken;

  if (!idToken) {
    throw new Error(i18n.t('toast.noValidSession'));
  }

  const payload = idToken.payload as Record<string, unknown>;
  const groups = (payload['cognito:groups'] as string[]) ?? [];

  const username = (payload['cognito:username'] ||
    payload.name ||
    payload.email ||
    payload.sub ||
    '') as string;

  const user: AuthUser = {
    email: payload.email as string,
    username,
    name: (payload.name || payload.email || '') as string,
    sub: payload.sub as string,
    id: (payload.name || payload.email || payload.sub || '') as string,
    roles: resolveRoles(groups),
    isAdmin: isAdminGroup(groups),
    locale: 'es',
  };

  return user;
};

export const resetAllProductRelatedStores = () => {
  useProductStore.getState().reset();
  useReceiptStore.getState().reset();
  useTrackingStore.getState().reset();
  useArrivalReceiptStore.getState().reset();
};

export const handleScanItemPageOpened = () =>
  useAppStore.getState().setCurrentScreen(SCREEN_TYPES.SCAN_ITEM);
export const handleCloseReceipt = () =>
  useAppStore.getState().setCurrentScreen(SCREEN_TYPES.CONFIRM_CLOSE);
